document.addEventListener("DOMContentLoaded", function () {
  const preOrderBtn = document.querySelector('[id^="PreOrderButton-"]');
  const preOrderModal = document.getElementById("preOrderModal");
  const closePreOrder = document.getElementById("closePreOrder");

  if (preOrderBtn && preOrderModal) {
    preOrderBtn.addEventListener("click", () => {
      preOrderModal.classList.remove("hidden");
    });
  }

  if (closePreOrder) {
    closePreOrder.addEventListener("click", () => {
      preOrderModal.classList.add("hidden");
    });
  }

  window.addEventListener("click", (e) => {
    if (e.target === preOrderModal) {
      preOrderModal.classList.add("hidden");
    }
  });
});

function openPreorderForm(productId) {
  console.log("Pre-Order button clicked for product:", productId);

  const popup = document.getElementById("preorder-popup");
  if (popup) {
    popup.style.display = "flex"; // show popup
    document.getElementById("preorder-product-id").value = productId;
  } else {
    console.log("Popup form not found in DOM");
  }
}

function closePreorderForm() {
  const popup = document.getElementById("preorder-popup");
  if (popup) {
    popup.style.display = "none";
    console.log("Pre-Order popup closed");
  }
}

document.getElementById("preorder-form").addEventListener("submit", function(e) {
  e.preventDefault(); // stop default redirect

  const form = e.target;
  const formData = new FormData(form);

  fetch(form.action, {
    method: "POST",
    body: formData,
    headers: { "Accept": "text/html" }
  })
  .then(response => {
    // hide form and show thank-you
    form.style.display = "none";
    document.getElementById("preorder-thankyou").style.display = "block";
  })
  .catch(error => {
    alert("Something went wrong. Please try again.");
    console.error(error);
  });
});